import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import IconUrl from '../../../../../../asset/User-Profile_Solid_E5E5E5_SVG.png'

const CancelPopUP = (props) => {
    const { remove, cancel, type, userData, beforeSuccess, okClosePopup, revokeSubscriptionData, cancelSubscriptionData } = props

    const handleParentClick = (e) => {
        e.stopPropagation();
    }

    return (
        <div className="confirm-assign-removal-container-two" onClick={cancel}>
            <div className="sp-alert-box-container" onClick={handleParentClick}>

                {!beforeSuccess ?
                    <div className="sp-alert-center">
                        <p className="alert-title">{props.title}</p>

                        <div className="image-wrapper">
                            <img
                                className='image-border'
                                src={revokeSubscriptionData?.imageProfileUrl || IconUrl}
                                alt="avatar"
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // prevent infinite loop
                                    e.currentTarget.src = IconUrl;  // fallback
                                }}
                            />
                        </div>

                        <div className='sp-data-container'>
                            <h3 className="user-name">{revokeSubscriptionData?.fullName || cancelSubscriptionData.fullName}</h3>
                            <h3 className="user-email"> {revokeSubscriptionData?.email || cancelSubscriptionData.email}</h3>

                            <div className="button-wrapper">
                                <div className="button-group">
                                    <button onClick={cancel} className="discard-btn">DISCARD</button>
                                    <button onClick={remove} className="confirm-btn">CONFIRM</button>
                                </div>
                            </div>
                        </div>

                    </div>
                    :
                    <div className="sp-alert-center">
                        <p className="alert-title">{props.successTitle}</p>

                        <div className="image-wrapper">
                            <img
                                className='image-border'
                                src={revokeSubscriptionData?.imageProfileUrl || IconUrl}
                                alt="avatar"
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // prevent infinite loop
                                    e.currentTarget.src = IconUrl;  // fallback
                                }}
                            />
                        </div>

                        <div className='sp-data-container'>
                            <h3 className="user-name">{revokeSubscriptionData?.fullName}</h3>
                            <h3 className="user-email">{revokeSubscriptionData?.email}</h3>

                            <div className="button-wrapper">
                                <div className="okay-button">
                                    <button onClick={okClosePopup} className="confirm-btn">Okay</button>
                                    {/* <button onClick={remove} className="confirm-btn">CONFIRM</button> */}
                                </div>
                            </div>
                        </div>

                    </div>}

            </div>
        </div>
    )
}


const mapStateToProps = state => ({
    manageSubscription: state.manageSubscription,
    assignSubscriptionTab: state.assignSubscriptionTab,
    userSubscription: state.userSubscription
})

const mapDispatchToProps = dispatch => ({
    openAssignSubscription: () => dispatch(openAssignSubscription()),
    closeAssignSubscription: () => dispatch(closeAssignSubscription()),
    fetchAssignedSubscription: (payload) => dispatch(fetchAssignedSubscription(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(CancelPopUP)
